import Modal from 'react-modal';
import {useState, createContext, useEffect} from 'react';
import { changeDisable, setMaskGeneric, viewItem, setMaskHour, dateToday, hoursNow, getPermission, showMessageError } from '../../../classes/functions';
import ModalDialog from '../../../components/Modal';
import './control.css';
import Title from '../../../components/Title';
import Header from '../../../components/Header';
import Division from '../../../components/Division';
import Lateral from '../../../components/Lateral';
import { toast } from 'react-toastify';
import api from '../../../config.js';
import { Link, useHistory, useParams } from 'react-router-dom';
import { FiCheck, FiPlus, FiSettings, FiClipboard } from 'react-icons/fi';
import { FaPen, FaArrowAltCircleLeft, FaCog } from 'react-icons/fa';
import ReactTooltip from "react-tooltip";
import InputDate from '../../../components/Inputs/Date/index.js';

const customStylesEnderecamento = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    width: '1050px',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
  },
};

export default function Order(){
  const { option, id } = useParams();
  const history = useHistory();
  const [view, setView] = useState(false);
  const [carrying, setCarrying] = useState(true);

  const [status, setStatus] = useState('');
  const [id_documento_entrada, setDocumentoEntrada] = useState('');
  const [numero_documento, setNumeroDocumento] = useState('');
  const [serie_documento, setSerieDocumento] = useState('');
  const [nome_cliente, setNomeCliente] = useState('');
  const [hora_entrada, setHoraEntrada] = useState('');

  const [label_palete, setLabelPalete] = useState('');

  const [modalEnderecamentoOpen, setEnderecamentoOpen] = useState(false);

  const [listUnidades, setListUnidades] = useState([]);
  const [listTiposProdutos, setListTipoProdutos] = useState([]);
  const [listStatusRecebimento, setListStatusRecebimento] = useState([]);
  const [listEnderecos, setListEnderecos] = useState([]);

  const [ident_enderecamento, setIdentEnderecamento] = useState('new');
  const [endereco_enderecamento, setEnderecoEnderecamento] = useState('');
  const [etiqueta_palete_enderecamento, setEtiquetaPaleteEnderecamento] = useState('');
  const [hora_enderecamento, setHoraEnderecamento] = useState('');
  const [usuario_enderecamento, setUsuarioEnderecamento] = useState('');

  const [disabled_enderecamento, setDisabledEnderecamento] = useState(true);
  const [viewItens, setViewItens] = useState([]);
  const [enderecamentoView, setEnderecamentoView] = useState([]);

  const [labelButton, setLabelButton] = useState('Adicionar');
  const [infos, setInfos] = useState({
    data_emissao: "",
    data_entrada: "",
  });
  const [addressing, setAddressing] = useState({
    data_enderecamento: ""
  });

  useEffect(()=> {
    async function loadAddressControl(){
      if (id) {
        getOne(id, option);
      }
    }

    getData();
    loadAddressControl();

  },[]);

  function getOne(id, option){
    api.get("/api/address_control/getList?id=" + id)
    .then((response) => {
      setDocumentoEntrada(response.data.row.id_documento_entrada);
      setStatus(response.data.row.status);
      setNumeroDocumento(response.data.row.numero_documento);
      setSerieDocumento(response.data.row.serie_documento);
      setNomeCliente(response.data.row.nome_cliente);
      setInfos((prevState) => ({...prevState, data_emissao: response.data.row.data_emissao, data_entrada: response.data.row.data_entrada}));
      setHoraEntrada(response.data.row.hora_entrada);

      setEnderecamentoView(response.data.enderecamento);

      setCarrying(false);
    }).catch((error) => {
      console.log(error);
      showMessageError(error.response.data);

      setCarrying(false);
    });

    setView(changeDisable(option));
  }

  function cancel(){
    history.push('/address_control');
  }

  function remove(){
    api.delete("/api/address_control/delete?id=" + id)
    .then((response) => {
        toast.success('Registro excluído com sucesso.');
        history.push('/address_control');
      }
    ).catch((error) => {
      showMessageError(error.response.data);
    });
  }
  
  async function getData() {
    api.get("/api/address_control/getDataPage")
    .then((response) => {
      setListUnidades(response.data.unidades);
      setListTipoProdutos(response.data.tipos_produtos);
      setListStatusRecebimento(response.data.status_recebimento);
      setListEnderecos(response.data.enderecos);

      setCarrying(false);
    }).catch((error) => {
      showMessageError(error.response.data);
    });
  }

  function closeModal() {
    setEnderecamentoOpen(false);
  }

  function showItem(ident, item) {
    let aux = [];
    
    item.itens.forEach(element => {
      aux.push(element);
    });

    setLabelPalete(item.etiqueta_palete_enderecamento);
    setViewItens(aux);
    setEnderecamentoOpen(true);
  }

  function editEnderecamento(ident, item) {
    if (item.finalizado_enderecamento === 'S') {
      setIdentEnderecamento(ident);
      
      setEnderecoEnderecamento(item.endereco_enderecamento);
      setEtiquetaPaleteEnderecamento(item.etiqueta_palete_enderecamento);
      setAddressing((prevState) => ({...prevState, data_enderecamento: item.data.enderecamento}));
      setHoraEnderecamento(item.hora_enderecamento);
      setUsuarioEnderecamento(item.usuario_enderecamento);
      setDisabledEnderecamento(false);

      setLabelButton('Salvar');
    } else {
      toast.error('Finalize o palete antes de endereçar.');
    }
  }

  function salvarEnderecamento() {
    if (ident_enderecamento !== 'new') {
      enderecamentoView[ident_enderecamento].endereco_enderecamento = endereco_enderecamento;
      enderecamentoView[ident_enderecamento].status_enderecamento = '003';
      enderecamentoView[ident_enderecamento].data_enderecamento = dateToday();
      enderecamentoView[ident_enderecamento].hora_enderecamento = hoursNow();
    } 

    setLabelButton('Adicionar');
    savePreview();
    inicializeEnderecamento();
  }

  function inicializeEnderecamento() {
    setIdentEnderecamento('new');
    setEnderecoEnderecamento('');
    setEtiquetaPaleteEnderecamento('');
    setAddressing((prevState) => ({...prevState, data_enderecamento: ""}));
    setHoraEnderecamento('');
    setUsuarioEnderecamento('');
    setDisabledEnderecamento(true);
  }

  function savePreview(){
    const data = {
      row: {
        id_documento_entrada: id_documento_entrada,
      },
      enderecamento: enderecamentoView,
    }

    if (id) { 
      data.row.id = id;

      api.put("/api/address_control/put", data)
      .then((response) => {
          setStatus(response.data.row.status);
     
          setListEnderecos(response.data.enderecos);
          setEnderecamentoView(response.data.enderecamento);
          toast.success('Endereçamento Realizado.');
        }
      ).catch((error) => {
        toast.error('Ops! Ocorreu um erro ao salvar as informações.');
      });
    }
  }
  
  return(
    <div>
      <Header/>
      <Division/>
      <Lateral/>
      <ReactTooltip />
            
      {carrying && <div className="content">
        <div className="divCarrying">
          <span>Carregando..</span>
          <FaCog icon="spinner" className="spinner" />
        </div>
      </div>}
      {!carrying && <div className="content">
        <Title name="Controle de Endereçamento">
          <Link to="/address_control">
            <FaArrowAltCircleLeft data-tip="Voltar" color="#001675" className="arrowIcon" size={40} />
          </Link>
        </Title>
        <div className="container">
          <form className="form-profile customers">
            <div className="containerGroupData">
              <h2>Dados Cadastrais</h2>
              <hr></hr>
            
              <div className="divGroup">
                <div className="formDiv">
                  <label>Status</label><br/>
                  <select value={status} onChange={ (e) => setStatus(e.target.value) } disabled={view}>
                    <option value="">Selecione</option>
                    {listStatusRecebimento.map((item, index) => (
                      <option key={index} value={item.chave}>{item.descricao}</option>
                    ))}
                  </select>
                </div>

                <div className="formDiv">
                  <label>Número do Documento</label><br/>
                  <input type="text" placeholder="Número do Documento" value={numero_documento} maxLength="9" disabled={true}/>
                </div>

                <div className="formDiv">
                  <label>Série do Documento</label><br/>
                  <input type="text" placeholder="Série do Documento" value={serie_documento} onChange={ (e) => setSerieDocumento(e.target.value) } maxLength="3" disabled={true}/>
                </div>
                
                <div className="formDiv">
                  <label>Cliente/Fornecedor</label><br/>
                  <input type="text" placeholder="Cliente/Fornecedor" value={nome_cliente} onChange={ (e) => setNomeCliente(e.target.value) } maxLength="60" disabled={true}/>
                </div>
              </div>

              <div className="divGroup">
                {/* <div className="formDiv">
                  <label>Cidade</label><br/>
                  <input type="text" placeholder="Cidade" value={cidade} onChange={ (e) => setCidade(e.target.value) } maxLength="60" disabled={true}/>
                </div>

                <div className="formDiv">
                  <label>Estado</label><br/>
                  <input type="text" placeholder="Estado" value={estado} onChange={ (e) => setEstado(e.target.value) }  maxLength="60" disabled={true}/>
                </div> */}

                <div className="formDiv">
                  <label>Data de Emissão</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_emissao" disabled />
                </div>

                <div className="formDiv">
                  <label>Data de Entrada</label><br/>
                  <InputDate filters={infos} setFilters={setInfos} propertyFilter="data_entrada" disabled />
                </div>

                <div className="formDiv">
                  <label>Hora de Entrada</label><br/>
                  <input type="text" placeholder="##:##:##" value={hora_entrada} onChange={ (e) => setHoraEntrada(setMaskGeneric(e.target.value, "##.##.##"))} maxLength="8" disabled={true}/>
                </div>
              </div>
            </div>
            <br />
            <div className="containerGroupData">
              <h2>Endereçamento</h2>
              <hr></hr>

              <div className="divGroup">
                <div className="formDivList">
                  <table>
                    <thead>
                      <tr>
                        <th className="ident-th">#</th>
                        <th className="min-th" scope="col">Etiqueta Palete</th>
                        <th className="min-th" scope="col">Endereço</th>
                        <th className="min-th" scope="col">Data</th>
                        <th className="min-th" scope="col">Hora</th>
                        <th className="min-th" scope="col">Usuário</th>
                        
                        <th scope="col" className='collumOption'>Opções</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr>
                        <td>
                          #
                        </td>
                        
                        <td>
                          <div className="formDivRow">
                            <input type="text" placeholder="Etiqueta Palete" value={etiqueta_palete_enderecamento} onChange={ (e) => setEtiquetaPaleteEnderecamento(e.target.value) } maxLength="14" disabled={true}/>
                          </div>
                        </td>
                        
                        <td>
                          <div className="formDivRow">
                            <select  data-tip data-for="registerTip" value={endereco_enderecamento} onChange={ (e) => setEnderecoEnderecamento(e.target.value) } disabled={disabled_enderecamento}>
                              <option value="">Selecione</option>
                              {listEnderecos.map((item, index) => (
                                <option key={index} value={item.id}>{item.descricao}</option>
                              ))}
                            </select>
                          </div>
                        </td>

                        <td>
                          <div className="formDiv">
                            <InputDate filters={addressing} setFilters={setAddressing} propertyFilter="data_enderecamento" disabled />
                          </div>
                        </td>

                        <td>
                          <div className="formDiv">
                            <input type="text" placeholder="##:##:##" value={hora_enderecamento} onChange={ (e) => setHoraEnderecamento(setMaskHour(e.target.value, "##.##.##"))} maxLength="8" disabled={true}/>
                          </div>
                        </td>

                        <td>
                          <div className="formDiv">
                            <input type="text" placeholder="Usuário" value={usuario_enderecamento} onChange={ (e) => setUsuarioEnderecamento(e.target.value)} maxLength="60" disabled={true}/>
                          </div>
                        </td>

                        {getPermission('OPERACOES - CONTROLE ENDERECAMENTO - CADASTRO') && <td data-label="Opções">
                          <button type="button" className="buttonModalList" onClick={salvarEnderecamento} disabled={view}>{labelButton}</button>
                        </td>}
                      </tr>
                      {enderecamentoView.map((item, index)=>{
                        return(
                          <tr key={index}>
                            <td>
                              {item.status_enderecamento === '001' ? <FiSettings data-tip="Em conferência" color="#F6a935" size={17}/> : '' } 
                              {item.status_enderecamento === '002' ? <FiClipboard data-tip="Pendente Endereçamento" color="#F00" size={17}/> : '' } 
                              {item.status_enderecamento === '003' ? <FiCheck data-tip="Finalizado" color="#001675" size={17}/> : '' } 
                              <ReactTooltip />
                            </td>
                            <td data-label="Etiqueta Palete">{item.etiqueta_palete_enderecamento}</td>
                            <td data-label="Endereço">{item.label_address_enderecamento}</td>
                            <td data-label="Data">{item.data_enderecamento}</td>
                            <td data-label="Hora">{item.hora_enderecamento}</td>
                            <td data-label="Usuário">{item.usuario_enderecamento}</td>

                            <td data-label="Opções">
                              {getPermission('OPERACOES - CONTROLE ENDERECAMENTO - CADASTRO') && item.status_enderecamento == '002' && <Link className="action" onClick={() => editEnderecamento(index, item)}>
                                <FaPen color="#000" size={17} />
                              </Link>}
                              <Link className="action" onClick={() => showItem(index, item)}>
                                <FiPlus color="#000" size={17} />
                              </Link>
                            </td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </form>
        </div>

        <Modal  
          isOpen={modalEnderecamentoOpen}
          onRequestClose={closeModal}
          style={customStylesEnderecamento}
          contentLabel="Itens Endereçamento"
          ariaHideApp={false}
        >
          <div className="body-modal">
            <div className="formDiv">
              <h3>Palete: {label_palete}</h3>
              <table>
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Produto</th>
                    <th>Tipo Produto</th>
                    <th>Unidade de Medida</th>
                    <th>Lote</th>
                    <th>Número Série</th>
                    <th>Número MAC</th>
                  </tr>
                </thead>
                <tbody>
                  {viewItens.map((item, index)=>{
                    return(
                      <tr key={index}>
                        <td>
                          {index+1}
                        </td>
                        <td data-label="Produto">{item.produto_enderecamento}</td>
                        <td data-label="Tipo Produto">{viewItem(listTiposProdutos, item.tipo_enderecamento)}</td>
                        <td data-label="Unidade de Medida">{viewItem(listUnidades, item.um_enderecamento)}</td>
                        <td data-label="Lote">{item.lote_enderecamento}</td>
                        <td data-label="Número Série">{item.numero_serie_enderecamento}</td>
                        <td data-label="Número MAC">{item.numero_mac_enderecamento}</td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
            </div>
            <div className="formDiv">
              <button type="button" className="buttonCancel" onClick={closeModal} disabled={view}>Fechar</button>
            </div>
          </div>
        </Modal>
      </div>}
    </div>
  )
}